module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service.cancel.title":"รายการถูกยกเลิก","service.cancel.description":"ถูกยกเลิกโดย {name} เมื่อ {time}","service.cancel.status_reason":"เนื่องจาก : {reason}"}}')
  delete Component.options._Ctor
}
